module.exports = __webpack_public_path__ + "static/media/guitar.515d9f6a.svg";